import { compose, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import { addIntlProps } from 'utils/recompose';
import { injectIntl } from 'react-intl';
import messages from './messages';
import { hideCartUpdateMessage } from 'reducers/websockets/actions';

export const confirm = ({ hideCartUpdateMessage }) => () => {
  window.location.reload();
  hideCartUpdateMessage();
};

export default compose(
  connect(
    null,
    {
      hideCartUpdateMessage,
    },
  ),
  injectIntl,
  addIntlProps({
    messages,
    propNames: ['cartUpdateMessage', 'confirmationMessage'],
  }),
  withHandlers({
    confirm,
  }),
);
